import { Injectable, Injector } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

export type RemoteResponse = { success: boolean | undefined, entity: any, message: string };

@Injectable()
export class RemoteServiceBase {
    protected readonly isGuest: boolean = false;
    protected readonly _route: ActivatedRoute;

    constructor(injector: Injector) {
        this._route = injector.get(ActivatedRoute);
        this.isGuest = this._route.snapshot.data['isGuest'];
    }

    protected validateResponse(result: RemoteResponse) {
        if (!result.success || !result.entity) {
            throw new Error(result.message);
        }
    }
}